export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-700-normal.woff2?e4002d0099fe3d561cf2fc048a678f59";